import { Component, input, output } from '@angular/core';
import {
  IonContent,
  IonRefresher,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresherContent,
  InfiniteScrollCustomEvent,
  RefresherCustomEvent
} from "@ionic/angular/standalone";

@Component({
  selector: 'lib-scrollable-elements-list',
  standalone: true,
  imports: [
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent
],
  templateUrl: './scrollable-elements-list.component.html',
  styles: [":host { display: block; }"]
})
export class ScrollableElementsList {

  manualRefresh = input(true);
  infiniteScroll = input(true);

  refresh = output<RefresherCustomEvent>();
  loadMore = output<InfiniteScrollCustomEvent>();

  onRefresh(e: RefresherCustomEvent) {
    this.refresh.emit(e);
  }

  onLoadMore(e: InfiniteScrollCustomEvent) {
    this.loadMore.emit(e);
  }
}
